import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0917 11.3595V5.91902C10.0917 5.42031 10.4997 5.01227 10.9984 5.01227C11.4971 5.01227 11.9052 5.42031 11.9052 5.91902V11.3595C11.9052 11.8582 11.4971 12.2663 10.9984 12.2663C10.4997 12.2663 10.0917 11.8582 10.0917 11.3595ZM10.9984 13.173C10.2458 13.173 9.63828 13.7806 9.63828 14.5332C9.63828 15.2858 10.2458 15.8933 10.9984 15.8933C11.751 15.8933 12.3585 15.2858 12.3585 14.5332C12.3585 13.7806 11.751 13.173 10.9984 13.173ZM21.4986 17.598C20.8639 18.8221 19.5309 19.5203 17.8625 19.5203H4.14336C2.46587 19.5203 1.14202 18.8221 0.507289 17.598C-0.136504 16.3648 0.0448463 14.7871 0.960665 13.4632L8.25095 1.92932C8.89474 1.00443 9.9103 0.478516 10.9984 0.478516C12.0865 0.478516 13.1021 1.00443 13.7187 1.90212L21.0452 13.4813C21.961 14.8052 22.1333 16.3739 21.4895 17.598H21.4986ZM19.5491 14.4969C19.5491 14.4969 19.5309 14.4788 19.5309 14.4606L12.2134 2.89954C11.9505 2.52777 11.4971 2.29202 10.9984 2.29202C10.4997 2.29202 10.0463 2.52777 9.76522 2.93581L2.46587 14.4606C1.90369 15.2586 1.77674 16.129 2.10317 16.7547C2.42053 17.3713 3.14594 17.7068 4.13429 17.7068H17.8444C18.8327 17.7068 19.5581 17.3713 19.8755 16.7547C20.2019 16.129 20.075 15.2586 19.54 14.4969H19.5491Z"
      fill="#F06400"
    />
  </svg>
);

const WarningIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default WarningIcon;
